/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Nativelanguage_Kornisch2Inputs */

const en__field__enum_nativelanguage_kornisch2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Kornisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kornisch`)
};

const de__field__enum_nativelanguage_kornisch2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Kornisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kornisch`)
};

/**
* | output |
* | --- |
* | "Kornisch" |
*
* @param {_Field__Enum_Nativelanguage_Kornisch2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_nativelanguage_kornisch2 = /** @type {((inputs?: _Field__Enum_Nativelanguage_Kornisch2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Nativelanguage_Kornisch2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_nativelanguage_kornisch2(inputs)
	return de__field__enum_nativelanguage_kornisch2(inputs)
});
export { _field__enum_nativelanguage_kornisch2 as "_field__enum_nativeLanguage_Kornisch" }